import { FC, useState } from "react"
import { Dialog, DialogContent } from "@/components/ui/dialog"
import ReactMarkdown from "react-markdown"

import { DocumentStagesData } from "@/hooks/useDocumentStages"

type SummaryDialogProps = {
	summary: string
	open: boolean
	onOpenChange: (open: boolean) => void
}

export const SummaryDialog: FC<SummaryDialogProps> = ({
	summary,
	open,
	onOpenChange,
}) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-y-auto">
				<div className="prose prose-sm max-w-none">
					<ReactMarkdown>{summary}</ReactMarkdown>
				</div>
			</DialogContent>
		</Dialog>
	)
}

type DocumentSummaryProps = {
	stagesData: DocumentStagesData
	preview: "one_line" | "two_line" | "four_line" | "full"
}

const PreviewComponent: FC<DocumentSummaryProps> = ({
	stagesData,
	preview,
}) => {
	if (preview === "one_line") {
		return <span className="text-sm">{stagesData.stage2.one_line_summary}</span>
	}
	if (preview === "two_line") {
		return <span className="text-sm">{stagesData.stage2.two_line_summary}</span>
	}
	if (preview === "four_line") {
		return <span className="text-sm block">{stagesData.stage2.four_line_summary}</span>
	}
	if (preview === "full") {
		return <ReactMarkdown>{stagesData.stage2.full_summary}</ReactMarkdown>
	}
}

export const DocumentSummary: FC<DocumentSummaryProps> = ({
	stagesData,
	preview,
}) => {
	const [open, setOpen] = useState(false)
	return (
		<>
			<button
				onClick={() => setOpen(true)}
				className="hover:text-primary transition-colors text-left"
				aria-label={`View full summary for document`}
			>
				<PreviewComponent stagesData={stagesData} preview={preview} />
			</button>
			<SummaryDialog
				summary={stagesData.stage2.full_summary}
				open={open}
				onOpenChange={setOpen}
			/>
		</>
	)
}
